const messages = {
	signUpSuccess: "Successfully registered! You've been signed in as well.",
	signUpFailure:"Registration failed. Email may be taken, or passwords don't match.",
	signInSuccess: 'Welcome!',
	signInFailure:'Failed to sign in. Check your email and password and try again.',
	signOutSuccess: 'Come back soon!',
	changePasswordSuccess: 'Password changed successfully!',
	changePasswordFailure:'Failed to change passwords. Check your old password and try again.',
	createBlogSuccess: "Blog Created Successfully",
	createBlogFailure: "Blog Failed to Create",
	createEventSuccess: "Event Created Successfully",
	createEventFailure: "Event Failed to Create"
}

module.exports = messages